import { LastGamesTable } from '@/components/organisms/LastGamesTable/LastGamesTable'
import { JackpotGamePanel } from '../organisms/JackpotGamePanel'
import { JackpotPlayersBets } from '../organisms/JackpotPlayersBets'
import { JackpotProvider } from '@/context/JackpotProvider'
import { AppModals, useAppModal } from '@/context/ModalProvider'
import { useEffect } from 'react'
import { useMaintenance } from '@/hooks/useMaintenance'

export const Jackpot = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return (
    <JackpotProvider>
      <JackpotGamePanel />
      <JackpotPlayersBets />
      <LastGamesTable />
    </JackpotProvider>
  )
}
